import { AmazonTheme } from '@openbank/cf-ui-static-data';

const THEME_PROVIDER_PROPS = {
  theme: AmazonTheme.default,
};

export * from './entrypoint.constants.common';
export { THEME_PROVIDER_PROPS };
